<template>
	<div>
		<el-upload action="#" accept=".mp4" :show-file-list="false" :auto-upload="false"
			:on-change="(file, fileList) => { handleVideo(file, fileList) }">
			<div class="upload">
				<div class="upload-btn" v-if="currentVal && !flag">
					<el-icon class="deleteIcon" @click.stop="delData">
						<el-icon-delete />
					</el-icon>
					<sc-video :src="currentVal"></sc-video>
				</div>
				<div class="upload-btn" v-else v-loading="flag" element-loading-text="上传中...">
					<el-icon>
						<el-icon-plus />
					</el-icon>
				</div>
				<div class="upload-progress" v-if="flag">
					<el-progress :percentage="percent" striped striped-flow :show-text="false" />
				</div>
			</div>

		</el-upload>
	</div>
</template>

<script setup>
import { uploadFileSlices } from "@/utils/useUpload"
import scVideo from "@/components/scVideo";
import { ElMessage, ElMessageBox } from 'element-plus'
import { computed, ref } from "vue"
import sysConfig from "@/config"
const props = defineProps({
	modelValue: {
		type: String,
		default: '',
	},
});
const emit = defineEmits(['update:modelValue']);
const currentVal = computed({
	get: () => props.modelValue,
	set: (val) => emit('update:modelValue', val)
})
const flag = ref(false);
const percent = ref(0);
const extractVideoPath = (url) => {
	const regex = /(\/video\/.*)/; // 正则表达式匹配/video及其后的所有内容[5,6](@ref)
	const match = url.match(regex);
	return match ? match[0] : null;
}

const handleVideo = (file) => {
	uploadFileSlices(file, {
		onTaskReady: () => {
			flag.value = true
		},
		success: (data) => {
			flag.value = false
			const url = extractVideoPath(data.url)
			if (url) {
				currentVal.value = `${sysConfig.CDN_URL}${url || ''}`
			} else {
				currentVal.value = data.url
			}
		},
		onProgress: (progressData) => {
			percent.value = Math.floor(progressData.percent * 100)
		}
	})
}
const delData = () => {
	ElMessageBox.confirm(
		`确定删除当前视频吗？`,
		'提示'
	).then(() => {
		currentVal.value = ''
		ElMessage({
			type: 'success',
			message: '操作成功',
		})
	}).catch(() => { })
}
</script>

<style lang="scss" scoped>
.upload {
	width: 300px;

	&-btn {
		width: 100%;
		height: 178px;
		border: 1px dashed #e2e2e2;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;
	}

	&-progress {
		margin-top: 6px;
	}
}


.deleteIcon {
	position: absolute;
	top: 0;
	right: 0;
	width: 25px;
	height: 25px;
	padding: 0 5px;
	background: var(--el-color-primary);
	color: #ffffff;
	z-index: 999;
}

::v-deep(.sc-video) {
	height: 100% !important;
}
</style>
